import { useState, useRef, useEffect } from "react";
import Header from "./Header";
import GreyArrow from "../assets/greyLeftAr.png";
import {
  Camera,
  Car,
  Trash2,
  Plus,
  Settings,
  FileText,
  Calendar,
  DollarSign,
  Fuel,
  Users,
  Key,
  Clipboard,
  Eye,
  Save,
  ImageIcon,
  Info,
  Gauge,
  Tag,
  Upload,
  Building,
  CheckSquare,
  AlertTriangle,
  Building2,
  ArrowLeft,
  ListChecks,
  MapIcon,
} from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./Css/AddCarDetailNew.css";
import { useLocation, useParams } from "react-router-dom";

import {
  APL_LINK,
  server_post_data,
  save_car_destails,
  cardetails_api_data,
  delete_multi_image,
  get_car_feature,
} from "../ServiceConnection/serviceconnection.js";
import { useNavigate } from "react-router-dom";
import {
  handleAlphabetsNumberWithoutSpaceChange,
  handleAlphabetsWithoutSpaceChange,
  handleError,
  handleSuccessSession,
  goBack,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery";
import { Button } from "@mui/material";
import Loader from "./Loader.js";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";
const AddCarDetailNew = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const isViewMode = location.pathname.includes("/view_car_detail");

  const [images, setImages] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [editorData, setEditorData] = useState("");
  const [error, setError] = useState("");
  const [isSingleImage, setIsSingleImage] = useState([]);
  const [isSingleImage1, setIsSingleImage1] = useState([]);
  const [isSingleImage2, setIsSingleImage2] = useState([]);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [activeTab, setActiveTab] = useState("basic");
  const [previewImage, setPreviewImage] = useState(null);
  const [cardetails, setshowcardetails] = useState([]);
  // Form fields state
  const [formData, setFormData] = useState({
    gearType: "",
    fuleType: "",
    seetCount: "",
    Model: "",
    year: "",
    color: "",
    vin: "",
    registeredTo: "",
    registrationDate: null,
    renewalDate: null,
    registration_company: "",
    registration_company_address: "",
    emissionsDue: null,
    inspection: "",
    inspValidity: null,
    company: "",
    carName: "",
    carTagline: "",
    carNo: "",
    price: "",
    carMileage: "",
    luggageCapacity: "",
    noOfDoors: "",
  });

  //old Componet dynamic states

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  const [cartype, setshowcartype] = useState([]);
  const [cartypevalue, setshowcartypevalue] = useState([]);
  const [showcaripassvalue, setshowcaripassvalue] = useState("");
  const [showcaripassnumber, setshowcaripassnumber] = useState("");
  const [gearType, setGearType] = useState("");
  const [carimage, setshowcarimage] = useState([]);
  const [carimagemulti, setshowcarimagemulti] = useState([]);
  const [imageold, setImageold] = useState(null);
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [fuleType, setFuleType] = useState("");
  const [seetCount, setSeetCount] = useState("");
  const [Model, setModel] = useState("");
  const [imagesBackend, setImagesBackend] = useState([]);
  const [year, setYear] = useState(cardetails.year || "");
  const [driverInfo, setdriverInfo] = useState([]);
  const [completeassignipass, setcompleteassignipass] = useState();
  const [caripassall, setcaripassall] = useState();
  // Refs
  const fileInputRef = useRef(null);
  const multipleFileInputRef = useRef(null);

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle date changes
  const handleDateChange = (date, field) => {
    const formattedDate = date
      ? `${String(date.getMonth() + 1).padStart(2, "0")}-${String(
          date.getDate(),
        ).padStart(2, "0")}-${date.getFullYear()}`
      : "";

    setFormData({
      ...formData,
      [field]: formattedDate,
    });
  };

  //-----old-Design_functionj

  // const handleImageUpload = (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   setImagesBackend(selectedFiles);
  //   if (images.length + selectedFiles.length > 8) {
  //     alert("You can only upload a maximum of 8 images.");
  //     return;
  //   }
  //   const newImageUrls = selectedFiles.map((file) => URL.createObjectURL(file));
  //   setImages([...images, ...newImageUrls]);
  // };
  const [registerImageview, setRegisterImageview] = useState(null);
  const [registerImageview2, setRegisterImage2view] = useState(null);
  const [registerImage, setRegisterImage] = useState(null);
  const [registerImage2, setRegisterImage2] = useState(null);
  const handleImageUpload1 = (e) => {
    const file = e.target.files[0];
    setIsSingleImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setImage2(null);
        setIsImageUploaded(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUploadRegisterImg = (e) => {
    const file = e.target.files[0];
    setIsSingleImage1(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setRegisterImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUploadRegisterImg2 = (e) => {
    const file = e.target.files[0];
    setIsSingleImage2(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setRegisterImage2(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleMultipleImageUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImagesBackend(selectedFiles);
    if (images.length + selectedFiles.length > 8) {
      setError("You can only upload a maximum of 8 images.");
      return;
    }
    const newImageUrls = selectedFiles.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => {
      const updatedImages = [...prevImages, ...newImageUrls];
      return updatedImages;
    });

    setError("");
  };

  const [selectedIpass, setSelectedIpass] = useState("");

  // Auto select logic based on `completeassignipass` and `caripassall`
  useEffect(() => {
    if (caripassall?.length > 0 && showcaripassnumber) {
      const matched = caripassall.find(
        (ipass) => ipass.ipass_id === showcaripassnumber,
      );
      if (matched) {
        setSelectedIpass(`${matched.primary_id}~@~${matched.ipass_id}`);
      }
    }
  }, [caripassall, showcaripassnumber]);

  // Handle editor change
  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
  };
  ///---------------get data
  useEffect(() => {
    // if (id !== undefined) {
    master_data_get();
    // }
  }, []);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    if (id !== undefined) {
      fd.append("main_id", id);
    }
    fd.append("flag", 3);
    await server_post_data(cardetails_api_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setshowcartype(Response.data.message.car_type);
          setshowcarimage(Response.data.message.car_image);
          setdriverInfo(Response.data.message.insurance_data);
          if (Response.data.message.cardetais.length > 0) {
            let data = Response.data.message.cardetais[0];
            setFormData({
              gearType: data.gear_type,
              fuleType: data.fuel_type,
              seetCount: data.seating_capacity,
              Model: "",
              year: data.make_year,
              color: data.color,
              vin: data.vin,
              // registeredTo: data.registered_to,
              registrationDate: data.registration_date,
              registration_company: data.registration_company,
              registration_company_address: data.registration_company_address,
              renewalDate: data.renewal_date,
              emissionsDue: data.emissions_due,
              inspection: data.inspection,
              inspValidity: data.insp_validity,
              company: data.company,
              carName: data.car_name,
              carTagline: data.car_tagline,
              carNo: data.car_no,
              price: data.Price,
              carMileage: data.car_mileage,
              luggageCapacity: data.storage_capacity,
              noOfDoors: data.no_of_door,
            });
            setEditorData(Response.data.message.cardetais[0].car_description);
            setshowcarimagemulti(Response.data.message.multiimage);
            setshowcardetails(Response.data.message.cardetais[0]);
            setImageold(Response.data.message.cardetais[0].image);
            setGearType(Response.data.message.cardetais[0].gear_type);
            setFuleType(Response.data.message.cardetais[0].fuel_type);
            setSeetCount(Response.data.message.cardetais[0].seating_capacity);
            setshowcaripassvalue(Response.data.message.cardetais[0].ipass_id);
            setshowcaripassnumber(
              Response.data.message.cardetais[0].ipass_number,
            );
            setcompleteassignipass(
              `${Response.data.message.cardetais[0].ipass_id}~@~${Response.data.message.cardetais[0].ipass_number}`,
            );
            setshowcartypevalue(
              `${Response.data.message.cardetais[0].model_name}~@~${Response.data.message.cardetais[0].model_id}`,
            );
            setRegisterImageview(
              APL_LINK +
                Response.data.message.car_image +
                Response.data.message.cardetais[0].registered_to,
            );
            setRegisterImage2view(
              APL_LINK +
                Response.data.message.car_image +
                Response.data.message.cardetais[0].inspection,
            );

            setImage2(
              APL_LINK +
                Response.data.message.car_image +
                Response.data.message.cardetais[0].image,
            );
            if (
              Response.data.message.cardetais[0].car_features != "" &&
              Response.data.message.cardetais[0].car_features != null
            ) {
              console.log(
                "car_features",
                Response.data.message.cardetais[0].car_features,
              );
              setSelectedFeatures(
                Response.data.message.cardetais[0].car_features.split("~@~"),
              );
            }
            setIsImageUploaded(true);
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.error(error);
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const formatToYYYYMMDD = (dateInput) => {
    const date = new Date(dateInput);
    if (isNaN(date)) return "";

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  // Handle Save Changes Dynamically
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    if (editorData.length > 0) {
      setshowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("image_old", imageold);
      fd_from.append("gear_type", "Manual");
      fd_from.append("fule_type", form_data.fuleType);
      fd_from.append("total_seats", form_data.seetCount);
      fd_from.append("car_model", cartypevalue);
      fd_from.append("make_year", form_data.year);
      fd_from.append("color", form_data.color);
      fd_from.append("vin", form_data.vin);
      fd_from.append("registeredTo", isSingleImage1);
      fd_from.append(
        "registrationDate",
        formatToYYYYMMDD(form_data.registrationDate),
      );
      fd_from.append("renewalDate", formatToYYYYMMDD(form_data.renewalDate));

      fd_from.append("emissionsDue", formatToYYYYMMDD(form_data.emissionsDue));
      fd_from.append("inspection", isSingleImage2);
      fd_from.append("inspValidity", formatToYYYYMMDD(form_data.inspValidity));
      fd_from.append("company", form_data.company);
      fd_from.append("carName", form_data.carName);
      fd_from.append("carTagline", form_data.carTagline);
      fd_from.append("carNo", form_data.carNo);
      fd_from.append("Price", form_data.price);
      fd_from.append("carMileage", form_data.carMileage);
      // fd_from.append("luggageCapacity", form_data.luggageCapacity);
      fd_from.append("luggageCapacity", "250");
      fd_from.append("image", isSingleImage);
      fd_from.append("noOfDoors", form_data.noOfDoors);
      // fd_from.append("ipassid", showcaripassvalue);
      // Only append if ipass_id has a value
      if (showcaripassvalue && showcaripassvalue !== "") {
        fd_from.append("ipassid", showcaripassvalue);
      } else {
        fd_from.append("ipassid", "0");
      }
      // OR set to null/0 instead of empty string

      fd_from.append("ipass_number", showcaripassnumber);
      fd_from.append("registration_company", form_data.registration_company);
      fd_from.append(
        "registration_company_address",
        form_data.registration_company_address,
      );
      fd_from.append("feature", selectedFeatures.join("~@~"));

      fd_from.append("message", editorData);
      imagesBackend.forEach((image, index) => {
        fd_from.append(`files`, image);
      });
      if (id !== undefined) {
        fd_from.append("call_id", id);
      }

      // Sending the data to the server
      await server_post_data(save_car_destails, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/view_cardetails");

            // empty_form(form_data);
            setFormData({
              gearType: "",
              fuleType: "",
              seetCount: "",
              Model: "",
              year: "",
              color: "",
              vin: "",
              registeredTo: "",
              registrationDate: null,
              renewalDate: null,
              emissionsDue: null,
              inspection: "",
              inspValidity: null,
              company: "",
              carName: "",
              carTagline: "",
              carNo: "",
              price: "",
              carMileage: "",
              luggageCapacity: "",
              noOfDoors: "",
              registration_company: "",
            });
            setshowcartypevalue("");
            setEditorData("");
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };

  // Handle Submit Function
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!editorData || editorData.length === 0) {
      setError("Please fill in the Overview section");
      return;
    }

    if (!isImageUploaded) {
      setError("Please upload a main car image");
      return;
    }

    if (!formData.carName) {
      setError("Please enter car model");
      return;
    }

    handleSaveChangesdynamic(formData);

    setIsLoading(false);
  };

  const handleImageRemove = async (index) => {
    let fd_from = new FormData();
    fd_from.append("name", index);
    await server_post_data(delete_multi_image, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get();
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });

    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle numbers only input
  const handleNumbersChange = (event) => {
    const { value } = event.target;
    const sanitizedValue = value.replace(/[^0-9]/g, "");
    event.target.value = sanitizedValue;
  };
  const handleNavigateBack = () => {
    navigate("/view_cardetails");
  };

  const handleViewClick = (event) => {
    event.stopPropagation(); // Prevent triggering file upload click
    if (registerImage) {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${registerImage}" style="max-width:50%; height:auto;" />`,
      );
      newTab.document.title = "Uploaded Image";
    } else {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${registerImageview}" style="max-width:50%; height:auto;" />`,
      );
      newTab.document.title = "Uploaded Image";
    }
  };
  const handleViewClick1 = (event) => {
    event.stopPropagation(); // Prevent triggering file upload click
    if (registerImage2) {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${registerImage2}" style="max-width:50%; height:auto;" />`,
      );
      newTab.document.title = "Uploaded Image";
    } else {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${registerImageview2}" style="max-width:50%; height:auto;" />`,
      );
      newTab.document.title = "Uploaded Image";
    }
  };
  const handleCompanyRegex = (e) => {
    const value = e.target.value;
    // const regex = /^[A-Za-z0-9\s.,]*$/; // Allows spaces, commas, and dots

    // if (regex.test(value)) {
      setFormData({ ...formData, registration_company: value });
    // }
  };

  const handleCompanyAdRegex = (e) => {
    const value = e.target.value;
    // const regex = /^[A-Za-z0-9\s.,]*$/; // Allows spaces, commas, and dots

    // if (regex.test(value)) {
    setFormData({ ...formData, registration_company_address: value });
    // }
  };
  const [carfeatures, setcarfeatures] = useState([]);
  const [caripass, setcaripass] = useState([]);
  const [imng_link, set_imng_link] = useState("");
  useEffect(() => {
    master_data_get_features();
  }, []);

  const master_data_get_features = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_car_feature, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          set_imng_link(APL_LINK + Response.data.message.image_link);
          setcarfeatures(Response.data.message.features);
          setcaripass(Response.data.message.ipass_data);
          setcaripassall(Response.data.message.ipass_data_all);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  //console.log("carfeatures", carfeatures);
  // Render form based on active tab
  const featureColumns = [
    [
      { id: "ac", name: "AC" },
      { id: "abs", name: "ABS" },
      { id: "airbag", name: "Air Bag" },
      { id: "ev", name: "EV" },
      { id: "cruiseControl", name: "Cruise Control" },
      { id: "4wd", name: "4WD" },
      { id: "airplay", name: "Airplay" },
      { id: "backupCamera", name: "Backup Camera" },
    ],
  ];

  //console.log("selectedFeatures", selectedFeatures);

  const handleFeatureToggle = (primary_id) => {
    const id = String(primary_id);
    setSelectedFeatures((prev) =>
      prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id],
    );
  };

  const handleIpass = (e) => {
    let data = e.split("~@~");
    setshowcaripassvalue(data[0]);
    setshowcaripassnumber(data[1]);
  };

  const renderFormContent = () => {
    switch (activeTab) {
      case "basic":
        return (
          <>
            <h4 className="form-section-title">
              <Info size={20} />
              Basic Information
            </h4>

            <div className="row mb-4">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="carName"
                    className="form-label required-field"
                  >
                    Model
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="carName"
                    name="carName"
                    placeholder="Enter Model"
                    defaultValue={formData.carName || cardetails.car_name}
                    onChange={handleInputChange}
                    required
                    readOnly={isViewMode}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="year" className="form-label required-field">
                    Make Year
                  </label>

                  <input
                    type="text"
                    name="year"
                    placeholder="Enter Year"
                    maxLength={4}
                    value={formData.year}
                    onChange={handleChange}
                    className="form-control"
                    onInput={handleNumbersChange}
                    required
                    readOnly={isViewMode}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="Model" className="form-label required-field">
                    Car Model Type
                  </label>
                  {/* {//console.log("cartypevalue",cartypevalue)} */}
                  <select
                    className="form-select"
                    id="Model"
                    name="Model"
                    value={cartypevalue}
                    // onChange={handleChange3}
                    onChange={(e) => setshowcartypevalue(e.target.value)}
                    required
                    disabled={isViewMode}
                  >
                    <option value="" disabled>
                      Select Car Type
                    </option>
                    {cartype &&
                      cartype.length > 0 &&
                      cartype.map((item, index) => (
                        <option
                          key={index}
                          value={`${item.name}~@~${item.primary_id}`}
                        >
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="color" className="form-label required-field">
                    Color
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="color"
                    name="color"
                    placeholder="Enter Color"
                    value={formData.color}
                    onChange={handleInputChange}
                    required
                    readOnly={isViewMode}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="carTagline"
                    className="form-label required-field"
                  >
                    Vehicle Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="carTagline"
                    name="carTagline"
                    placeholder="Enter tag line"
                    value={formData.carTagline}
                    onChange={handleInputChange}
                    required
                    readOnly={isViewMode}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="price" className="form-label required-field">
                    Price
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <DollarSign size={18} />
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      id="price"
                      name="price"
                      placeholder="Enter Price"
                      min="0"
                      value={formData.price}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="price" className="form-label">
                    Default Assigned I-Pass
                  </label>
                  <select
                    className="form-select"
                    id="Model"
                    name="Model"
                    value={selectedIpass}
                    onChange={(e) => {
                      setSelectedIpass(e.target.value);
                      handleIpass(e.target.value);
                    }}
                    disabled={isViewMode}
                  >
                    <option value="" disabled>
                      Assign I-pass
                    </option>
                    {caripassall &&
                      // Create a new filtered list with unique entries:
                      [
                        ...new Map(
                          // Combine active ipass + assigned ipass
                          [
                            // Active ipasses
                            ...caripassall.filter(
                              (ipass) => ipass.ipass_status === 1,
                            ),
                            // Assigned ipass (even if inactive)
                            ...caripassall.filter(
                              (ipass) => ipass.ipass_id === showcaripassnumber,
                            ),
                          ].map((ipass) => [
                            // Unique key: ipass_id
                            ipass.ipass_id,
                            ipass,
                          ]),
                        ).values(),
                      ].map((ipass, index) => (
                        <option
                          key={index}
                          value={`${ipass.primary_id}~@~${ipass.ipass_id}`}
                        >
                          {ipass.ipass_id}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="" className="form-label required-field">
                    Select I-Pass
                  </label>
                  <select
                    className="form-select"
                    id="Model"
                    name="Model"
                    defaultValue={completeassignipass}
                    onChange={(e) => handleIpass(e.target.value)}
                    required
                    disabled={isViewMode}
                  >
                    <option value="" disabled>
                      Select Car Type
                    </option>
                    {caripassall && caripassall.length > 0 && caripassall.map((ipass, index) => (
                      <option key={index} value={`${ipass.primary_id}~@~${ipass.ipass_id}`}>{ipass.ipass_id}</option>
                    ))}
                  </select>
                </div>
              </div> */}
              {/* <select
                className="form-select"
                id="Model"
                name="Model"
                value={selectedIpass}
                onChange={(e) => {
                  setSelectedIpass(e.target.value);
                  handleIpass(e.target.value);
                }}
                required
                disabled={isViewMode}
              >
                <option value="" disabled>
                  Select Car Type
                </option>
                {caripassall &&
                  caripassall.map((ipass, index) =>
                    ipass.ipass_status === 1 ? (
                      <option
                        key={index}
                        value={`${ipass.primary_id}~@~${ipass.ipass_id}`}
                      >
                        {ipass.ipass_id}
                      </option>
                    ) : null
                  )}
              </select> */}
            </div>
          </>
        );

      case "technical":
        return (
          <>
            <h4 className="form-section-title">
              <Settings size={20} />
              Technical Specifications
            </h4>

            <div className="row mb-4">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="seetCount"
                    className="form-label required-field"
                  >
                    Seat Count
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Users size={18} />
                    </span>
                    <select
                      className="form-select"
                      id="seetCount"
                      name="seetCount"
                      value={formData.seetCount}
                      onChange={handleChange}
                      required
                      disabled={isViewMode}
                    >
                      <option value="" disabled>
                        Select Seat Count
                      </option>
                      <option value="2">2 Seats</option>
                      <option value="4">4 Seats</option>
                      <option value="5">5 Seats</option>
                      <option value="7">7 Seats</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="gearType"
                    className="form-label required-field"
                  >
                    Gear Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Settings size={18} />
                    </span>
                    <select
                      className="form-select"
                      id="gearType"
                      name="gearType"
                      value={formData.gearType}
                      onChange={(e) => handleChange(e)}
                      required
                      disabled={isViewMode}
                    >
                      <option value="" disabled>
                        Select Gear Type
                      </option>
                      <option value="manual">Manual</option>
                      <option value="automatic">Automatic</option>
                    </select>
                  </div>
                </div>
              </div> */}

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="fuleType"
                    className="form-label required-field"
                  >
                    Fuel Type
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Fuel size={18} />
                    </span>
                    <select
                      className="form-select"
                      name="fuleType"
                      value={formData.fuleType}
                      onChange={handleChange}
                      required
                      disabled={isViewMode}
                    >
                      <option value="" hidden>
                        Select Fuel Type
                      </option>
                      <option value="Gas">Gas</option>
                      <option value="Hybrid">Hybrid</option>
                      {/* <option value="cng">CNG</option> */}
                      {/* <option value="Electric(Ev)">Electric(Ev)</option> */}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="noOfDoors"
                    className="form-label required-field"
                  >
                    Number of Doors
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Car size={18} />
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      id="noOfDoors"
                      name="noOfDoors"
                      placeholder="Enter Number of Doors"
                      min="0"
                      value={formData.noOfDoors}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="carMileage"
                    className="form-label required-field"
                  >
                    Mileage
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Gauge size={18} />
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      id="carMileage"
                      name="carMileage"
                      placeholder="Enter Mileage"
                      min="0"
                      value={formData.carMileage}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="luggageCapacity"
                    className="form-label required-field"
                  >
                    Luggage Capacity
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="luggageCapacity"
                    name="luggageCapacity"
                    placeholder="Enter Luggage Capacity"
                    min="0"
                    value={formData.luggageCapacity}
                    onChange={handleInputChange}
                    required
                    readOnly={isViewMode}
                  />
                </div>
              </div> */}
            </div>
          </>
        );

      case "registration":
        return (
          <>
            <h4 className="form-section-title">
              <FileText size={20} />
              Registration & Identification
            </h4>

            <div className="row mb-4">
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="vin" className="form-label required-field">
                    VIN
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Key size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="vin"
                      name="vin"
                      placeholder="Enter VIN"
                      value={formData.vin}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                      maxLength={17}
                      onInput={handleAlphabetsNumberWithoutSpaceChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="carNo" className="form-label required-field">
                    License Plate
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Tag size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="carNo"
                      name="carNo"
                      placeholder="Enter LP Number"
                      value={formData.carNo}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                      maxLength={8}
                      onInput={handleAlphabetsNumberWithoutSpaceChange}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="registeredTo"
                    className="form-label required-field"
                  >
                    Registered To
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <MapPin size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="registeredTo"
                      name="registeredTo"
                      placeholder="Enter Registered To"
                      value={formData.registeredTo}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                    />
                  </div>
                </div>
              </div> */}

              <div className="col-md-6">
                {console.log("resiImg", registerImageview)}
                <div className="mb-3">
                  <div className="insePectDiv">
                    <label
                      htmlFor="fileUpload"
                      className="form-label required-field"
                    >
                      Registered Image
                    </label>
                    {!isViewMode && (
                      <>
                        {!location.pathname.includes("/AddCarDetailNew") && (
                          <span
                            className="hamndlViewImg"
                            onClick={handleViewClick}
                          >
                            <Eye className="icon_imgGG" size={18} />
                          </span>
                        )}
                      </>
                    )}
                  </div>
                  {!isViewMode && (
                    <input
                      type="file"
                      className="form-control"
                      id="registrr_img"
                      name="fileUpload"
                      accept="image/*"
                      onChange={(e) => {
                        if (!isViewMode) {
                          handleUploadRegisterImg(e);
                        }
                      }}
                      disabled={isViewMode}
                      readOnly={isViewMode}
                    />
                  )}

                  {isViewMode && (
                    <div className="isViewImgShow">
                      <span
                        className="input-group-text vieICn"
                        onClick={registerImageview ? handleViewClick : null}
                        style={{
                          cursor: registerImageview ? "pointer" : "default",
                        }}
                      >
                        <Eye size={18} />
                      </span>
                      {registerImageview ? (
                        <p>View your image: </p>
                      ) : (
                        <p style={{ color: "red" }}>
                          Error: No image available!
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="company"
                    className="form-label required-field"
                  >
                    Company
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Building size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="company"
                      name="company"
                      placeholder="Enter Company"
                      value={formData.company}
                      onChange={handleInputChange}
                      required
                      readOnly={isViewMode}
                    />
                  </div>
                </div>
              </div> */}

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="registrationDate"
                    className="form-label required-field"
                  >
                    Registration Date
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Calendar size={18} />
                    </span>
                    <DatePicker
                      selected={
                        formData.registrationDate
                          ? new Date(formData.registrationDate)
                          : null
                      }
                      onChange={(date) =>
                        handleDateChange(date, "registrationDate")
                      }
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      placeholderText="Select Registration Date"
                      id="registrationDate"
                      required
                      disabled={isViewMode}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="renewalDate"
                    className="form-label required-field"
                  >
                    Renewal Date
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Calendar size={18} />
                    </span>
                    <DatePicker
                      selected={
                        formData.renewalDate
                          ? new Date(formData.renewalDate)
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "renewalDate")}
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      placeholderText="Select Renewal Date"
                      id="renewalDate"
                      required
                      disabled={isViewMode}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="registeredTo"
                    className="form-label required-field"
                  >
                    Registration Company
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Building2 size={18} />
                    </span>
                    {console.log(
                      "Company_rgitrer",
                      formData.registration_company,
                    )}
                    <input
                      type="text"
                      className="form-control"
                      id="registration_company"
                      name="registration_company"
                      placeholder="Enter Registered To"
                      value={formData.registration_company}
                      required
                      readOnly={isViewMode}
                      onChange={handleCompanyRegex}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="registration_company_address"
                    className="form-label required-field"
                  >
                    Registration Company Address
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <MapIcon size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="registration_company_address"
                      name="registration_company_address"
                      placeholder="Enter Company Address"
                      value={formData?.registration_company_address}
                      required
                      readOnly={isViewMode}
                      onChange={handleCompanyAdRegex}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );

      case "inspection":
        return (
          <>
            <h4 className="form-section-title">
              <CheckSquare size={20} />
              Inspection & Emissions
            </h4>

            <div className="row mb-4">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="emissionsDue"
                    className="form-label required-field"
                  >
                    Emissions Due On
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <AlertTriangle size={18} />
                    </span>
                    <DatePicker
                      selected={formData.emissionsDue}
                      onChange={(date) =>
                        handleDateChange(date, "emissionsDue")
                      }
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      placeholderText="Select Emissions Due Date"
                      id="emissionsDue"
                      required
                      disabled={isViewMode}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <div className="insePectDiv">
                    <label
                      htmlFor="fileUpload"
                      className="form-label required-field"
                    >
                      Inspection Image
                    </label>
                    {!isViewMode && (
                      <>
                        {!location.pathname.includes("/AddCarDetailNew") && (
                          <span
                            className="hamndlViewImg"
                            onClick={handleViewClick1}
                          >
                            <Eye className="icon_imgGG" size={18} />
                          </span>
                        )}
                      </>
                    )}
                  </div>

                  {!isViewMode && (
                    <input
                      type="file"
                      className="form-control"
                      id="registrr_img2"
                      name="fileUpload"
                      accept="image/*"
                      style={{ cursor: isViewMode ? "default" : "pointer" }}
                      onChange={(e) => {
                        if (!isViewMode) {
                          handleUploadRegisterImg2(e);
                        }
                      }}
                      disabled={isViewMode}
                      readOnly={isViewMode}
                    />
                  )}
                  {isViewMode && (
                    <div className="isViewImgShow">
                      <span
                        className="input-group-text vieICn"
                        onClick={registerImageview2 ? handleViewClick1 : null}
                        style={{
                          cursor: registerImageview2 ? "pointer" : "default",
                        }}
                      >
                        <Eye size={18} />
                      </span>
                      {registerImageview2 ? (
                        <p>View your image: </p>
                      ) : (
                        <p style={{ color: "red" }}>
                          Error: No image available!
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="inspValidity"
                    className="form-label required-field"
                  >
                    Inspection Validity
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Calendar size={18} />
                    </span>
                    <DatePicker
                      selected={formData.inspValidity}
                      onChange={(date) =>
                        handleDateChange(date, "inspValidity")
                      }
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      placeholderText="Select Inspection Validity Date"
                      id="inspValidity"
                      required
                      disabled={isViewMode}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );

      case "description":
        return (
          <>
            <h4 className="form-section-title">
              <FileText size={20} />
              Car Overview
            </h4>

            <div className="mb-4">
              <label className="form-label required-field">Overview</label>
              <CKEditor
                editor={ClassicEditor}
                data={editorData}
                onChange={handleEditorChange}
                disabled={isViewMode}
              />
            </div>
          </>
        );
      case "features":
        return (
          <>
            <h4 className="form-section-title">
              <ListChecks size={20} />
              Features
            </h4>

            <div className="row add_feature_contrr">
              {carfeatures.map((feature, index) => (
                <div key={index} className="col-md-4">
                  <div
                    key={index}
                    className="form-check feature-item"
                    onClick={(e) => {
                      if (!isViewMode) {
                        handleFeatureToggle(feature.primary_id);
                      } else {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }}
                    style={{ pointerEvents: isViewMode ? "none" : "auto" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={feature.primary_id}
                      checked={selectedFeatures.includes(
                        String(feature.primary_id),
                      )}
                      disabled={isViewMode}
                    />
                    <label className="form-check-label" htmlFor={feature.id}>
                      {feature.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </>
        );
      default:
        return null;
    }
  };
  const formHeight =
    carimagemulti.length > 5
      ? "calc(100vh - 160px)"
      : carimagemulti.length < 4 || carimagemulti.length === 0
        ? "calc(100vh - 160px)"
        : "calc(100vh - 160px)";

  const formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="add_car_detail_new_cont NewDesignCarDetail">
        <div className="pageCntn_head" style={{ top: "0px" }}>
          <div className="pageNameDiv">
            {/* <p>
              {location.pathname.includes("/edit_cardetails") ? (
                <p>Update Car</p>
              ) : location.pathname.includes("/view_car_detail") ? (
                <p>View Car Detail</p>
              ) : (
                <p>Add Car</p>
              )}
            </p> */}

            {/* <img src={GreyArrow} alt="Rapid Car Leasing" /> */}
            <Breadcrumb
              items={[
                { label: "View Cars", path: "/view_cardetails" },
                {
                  label: location.pathname.includes("/edit_cardetails")
                    ? "Update Car"
                    : location.pathname.includes("/view_car_detail")
                      ? "View Car Detail"
                      : "Add Car",
                  path: location.pathname,
                },
              ]}
            />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>

        {isLoading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}

        {error && (
          <div
            className="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {error}
            <button
              type="button"
              className="btn-close"
              onClick={() => setError("")}
            ></button>
          </div>
        )}

        {isViewMode && driverInfo.length > 0 ? (
          <div className="top_data_Show_view">
            <div className="driver-info-card">
              <div className="card">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Driver Information</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="info-item">
                        <span className="info-label">Driver Name</span>
                        <span className="info-value">
                          {driverInfo[0].driver_name}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="info-item">
                        <span className="info-label">Booking Start</span>
                        <span className="info-value">
                          {formatDate(driverInfo[0]?.booking_start_date)}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="info-item">
                        <span className="info-label">Policy ID</span>
                        <span className="info-value">
                          {driverInfo[0].insurance_policy}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="info-item">
                        <span className="info-label">Policy Company</span>
                        <span className="info-value">
                          {driverInfo[0].insurance_company}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="info-item">
                        <span className="info-label">Insurance Expiry</span>
                        <span className="info-value">
                          {formatDate(driverInfo[0].insurance_expiration_date)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <form
          className="car_detl_form MargnClssw"
          onSubmit={handleSubmit}
          style={{ height: formHeight }}
        >
          <div className="row position-relative">
            {/* Left Column - Car Details Form */}
            <div className="col-xxl-8 mt-2">
              <div className="form-card">
                {/* Tab Navigation */}
                <div className="form-tabs">
                  <div
                    className={`form-tab ${
                      activeTab === "basic" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("basic")}
                  >
                    <Info size={18} />
                    Basic Info
                  </div>
                  <div
                    className={`form-tab ${
                      activeTab === "technical" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("technical")}
                  >
                    <Settings size={18} />
                    Technical
                  </div>
                  <div
                    className={`form-tab ${
                      activeTab === "registration" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("registration")}
                  >
                    <FileText size={18} />
                    Registration
                  </div>
                  <div
                    className={`form-tab ${
                      activeTab === "inspection" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("inspection")}
                  >
                    <CheckSquare size={18} />
                    Inspection
                  </div>
                  <div
                    className={`form-tab ${
                      activeTab === "description" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("description")}
                  >
                    <FileText size={18} />
                    Description
                  </div>
                  <div
                    className={`form-tab ${
                      activeTab === "features" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("features")}
                  >
                    <FileText size={18} />
                    Features
                  </div>
                </div>

                {/* Form Content based on active tab */}
                {renderFormContent()}
              </div>
            </div>

            {/* Right Column - Image Upload */}
            <div className="col-xxl-4  mt-2">
              <div className="form-card">
                <h4 className="form-section-title">
                  <Camera size={20} />
                  Main Car Image
                </h4>

                <div
                  className={`image-upload-container ${
                    isImageUploaded ? "has-image" : ""
                  } ${isViewMode ? "disabled" : ""}`}
                  onClick={() => !isViewMode && fileInputRef.current.click()}
                  style={
                    isViewMode
                      ? { cursor: "default", pointerEvents: "none" }
                      : {}
                  }
                  title="Image Size:400x300 px"
                >
                  {isImageUploaded ? (
                    image2 !== null ? (
                      <img
                        src={image2 || "/placeholder.svg?height=200&width=300"}
                        alt="Car"
                        className="preview"
                      />
                    ) : (
                      <img
                        src={image || "/placeholder.svg?height=200&width=300"}
                        alt="Car"
                        className="preview"
                      />
                    )
                  ) : (
                    <>
                      <div className="image-upload-icon">
                        <Camera />
                      </div>
                      <div className="image-upload-text">
                        Click to upload main car image
                      </div>
                      <span style={{ fontSize: "12px", color: "red" }}>
                        Upload an Image of Size 400x300 px
                      </span>
                    </>
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="image/*"
                    name="image"
                    style={{ display: "none" }}
                    onChange={handleImageUpload1}
                  />
                </div>

                <h4 className="form-section-title mt-4">
                  <ImageIcon size={20} />
                  Additional Images
                </h4>
                <>
                  <p className="text-muted " style={{ marginBottom: "0px" }}>
                    You can upload up to 8 additional images
                  </p>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#777",
                      margin: "0px",
                      color: "red",
                    }}
                  >
                    Upload an Image of Size 1800x1000 px
                  </span>
                </>

                <div className="image-gallery">
                  {carimagemulti.map((image, index) => (
                    <div
                      className="image-item"
                      key={`new-${index}`}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <img
                        src={
                          APL_LINK + carimage + image["image"] ||
                          "/placeholder.svg?height=100&width=100"
                        }
                        alt={`Car view ${index + 1}`}
                      />

                      {hoveredIndex === index && !isViewMode && (
                        <button
                          className="delete-btn"
                          onClick={() => handleImageRemove(image["image"])}
                          type="button"
                        >
                          <Trash2 size={16} />
                        </button>
                      )}
                    </div>
                  ))}
                  {images.map((image, index) => (
                    <div
                      className="image-item"
                      key={`new-${index}`}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <img
                        src={image || "/placeholder.svg?height=100&width=100"}
                        alt={`Car view ${index + 1}`}
                      />
                      {hoveredIndex === index && (
                        <button
                          className="delete-btn"
                          onClick={() => handleImageRemove(index)}
                          type="button"
                        >
                          <Trash2 size={16} />
                        </button>
                      )}
                    </div>
                  ))}
                  {images.length < 8 && !isViewMode && (
                    <div
                      className="add-image-btn"
                      onClick={() => multipleFileInputRef.current.click()}
                      title="Image Size: 1800x1000 px"
                    >
                      <Plus size={24} />
                      <input
                        type="file"
                        ref={multipleFileInputRef}
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleMultipleImageUpload}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {!isViewMode && (
            <div className="saveBttn_div">
              <button type="submit">
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>Save Car Details</>
                )}
              </button>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default AddCarDetailNew;
